"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icons = exports.Colors = void 0;
var Colors;
(function (Colors) {
    Colors["primary"] = "#1d2331";
    Colors["primaryDark"] = "#191e2b";
    Colors["primaryDarkest"] = "#0c0e14";
    Colors["red"] = "#f24c3d";
    Colors["redDark"] = "#d32f2f";
    Colors["pinkLight"] = "#fcdee8";
    Colors["pink"] = "#e62265";
    Colors["redLight"] = "#fde4e2";
    Colors["purple"] = "#9c27b0";
    Colors["purpleLight"] = "#f0dff3";
    Colors["purpleDark"] = "#7b1fa2";
    Colors["deepPurple"] = "#512DA8";
    Colors["lightDeepPurple"] = "#e8e2f4";
    Colors["deepPurpleDark"] = "#512da8";
    Colors["lightIndigo"] = "#e2e5f2";
    Colors["indigo"] = "#3f51b5";
    Colors["indigoLight"] = "#e2e5f4";
    Colors["indigoDark"] = "#303f9f";
    Colors["blue"] = "#2196f3";
    Colors["blueLight"] = "#def0fd";
    Colors["blueDark"] = "#1976d2";
    Colors["lightBlueLight"] = "#d9f2fe";
    Colors["lightBlue"] = "#03a9f4";
    Colors["lightBlueHeader"] = "#fbfcfd";
    Colors["lightBlueTile"] = "#f8fcfd";
    Colors["paletteLightBlue"] = "#e3f2fd";
    Colors["lightBlueSelect"] = "#f7fbfd";
    Colors["lightBlueDark"] = "#0288d1";
    Colors["lightCyan"] = "#d9f5f9";
    Colors["cyanDark"] = "#0097a7";
    Colors["cyan"] = "#00bcd4";
    Colors["tealLight"] = "#d9f0ed";
    Colors["teal"] = "#009688";
    Colors["tealDark"] = "#00796b";
    Colors["greenLightest"] = "#f8fbf8";
    Colors["greenLight"] = "#e7f3e7";
    Colors["greenLighter"] = "#e7f5e9";
    Colors["green"] = "#4caf50";
    Colors["greenDark"] = "#388e3c";
    Colors["greenActive"] = "#E6F7E3";
    Colors["greenFeatureTile"] = "#F4FFF0";
    Colors["lightGreenLight"] = "#eef6e4";
    Colors["lightGreen"] = "#8bc34a";
    Colors["lightGreenDark"] = "#689f38";
    Colors["limeLight"] = "#f8fae2";
    Colors["lime"] = "#cddc39";
    Colors["limeLightDark"] = "#afb42b";
    Colors["yellowLight"] = "#fffce2";
    Colors["yellow"] = "#ffeb3b";
    Colors["yellowDark"] = "#fbc02d";
    Colors["amberLight"] = "#fff6da";
    Colors["amber"] = "#ffc107";
    Colors["amberDark"] = "#ffa000";
    Colors["veryLightOrange"] = "#fffaf2";
    Colors["orangeLighter"] = "#fff3e0";
    Colors["orangeLight"] = "#fff0d9";
    Colors["orange"] = "#ff9800";
    Colors["orangeDark"] = "#f57c00";
    Colors["deepOrangeLight"] = "#ffe6de";
    Colors["deepOrange"] = "#ff5722";
    Colors["deepOrangeDark"] = "#e64a19";
    Colors["brownLight"] = "#EFEBE9";
    Colors["brown"] = "#795548";
    Colors["brownDark"] = "#6D4C41";
    Colors["darkBrown"] = "#5d4037";
    Colors["primaryLightest"] = "#7b95cc";
    Colors["primaryLight"] = "#5c7099";
    Colors["primaryLightGrey"] = "#f2f2f2";
    Colors["primaryGrey"] = "#e5e5e5";
    Colors["primaryDarkGrey"] = "#a6a6a6";
    Colors["primaryGreyDarkest"] = "#808080";
    Colors["charcoal"] = "#333333";
    Colors["grey2"] = "#222222";
    Colors["black"] = "#000000";
    Colors["white"] = "#ffffff";
    Colors["tealCatalog"] = "#26C6DA";
    Colors["lightBlueCatalog"] = "#2AB6F6";
    Colors["blueCatalog"] = "#42A5F5";
    Colors["darkBlueCatalog"] = "#5C6BC0";
    Colors["purpleCatalog"] = "#7E57C2";
    Colors["lightPurpleCatalog"] = "#AB47BC";
    Colors["pinkCatalog"] = "#ED407A";
    Colors["redCatalog"] = "#EF5350";
    Colors["orangeCatalog"] = "#FF7043";
    Colors["darkYellowCatalog"] = "#FFCA27";
    Colors["yellowCatalog"] = "#FFEE59";
    Colors["yellowGreenCatalog"] = "#D4E157";
    Colors["lightGreenCatalog"] = "#9CCC65";
    Colors["greenCatalog"] = "#66BB69";
    Colors["darkGreenCatalog"] = "#26A69A";
    Colors["brownCatalog"] = "#8D6E63";
    Colors["skyBlue"] = "#E3F2FD";
    Colors["veryLightPink"] = "#cccccc";
    Colors["greyLight"] = "#fafafa";
    Colors["greyFade"] = "#969696";
    Colors["brandPrimary"] = "#3023ae";
    Colors["brandSecondary"] = "#c86dd7";
    Colors["modalBgColor"] = "rgba(0,0,0,0.6)";
    Colors["transparent"] = "#ffffff00";
    Colors["whiteTransparent"] = "rgba(255, 255, 255, 0.67)";
    Colors["warning"] = "#ffebee";
    Colors["blackTransparent01"] = "rgba(0,0,0,0.1)";
    Colors["blackTransparent02"] = "rgba(0,0,0,0.2)";
    Colors["blackTransparent03"] = "rgba(0,0,0,0.3)";
    Colors["redNegative"] = "#f44336";
    Colors["faitOrange"] = "#fffcf6";
    Colors["amberLightest"] = "#FFC008";
    Colors["redLightest"] = "#FFF9FA";
})(Colors = exports.Colors || (exports.Colors = {}));
var Icons;
(function (Icons) {
    Icons["Check"] = "Check";
    Icons["CheckCircle"] = "CheckCircle";
    Icons["Warning"] = "exclamation-triangle";
    Icons["Uncheck"] = "Uncheck";
    Icons["TickMark"] = "Tick";
    Icons["Delete"] = "trash-alt";
    Icons["Edit"] = "pen";
    Icons["Plus"] = "Plus";
    Icons["Times"] = "times";
    Icons["AngleRight"] = "AngleRight";
    Icons["ArrowRight"] = "ArrowRight";
    Icons["ArrowLeft"] = "ArrowLeft";
    Icons["Circle"] = "circle";
    Icons["RecordAudio"] = "recordAudio";
    Icons["USDCircle"] = "usd-circle";
    Icons["PlusCircle"] = "plus-circle";
    Icons["MinusCircle"] = "minus-circle";
    Icons["Split"] = "align-center-h";
    Icons["Redo"] = "redo";
    Icons["Print"] = "print";
    Icons["InfoCircle"] = "info-circle";
    Icons["ArrowUp"] = "arrow-up";
    Icons["ArrowDown"] = "arrow-down";
    Icons["SquareShape"] = "square-shape";
    Icons["CheckSquare"] = "check-square";
    Icons["MinusSquare"] = "minus-square";
    Icons["SquareFull"] = "square-full";
    Icons["MinusSquareFull"] = "minus-square-full";
    Icons["AngleUp"] = "angle-up";
    Icons["AngleDown"] = "angle-down";
    Icons["UserCircle"] = "user-circle";
    Icons["UsersAlt"] = "users-alt";
    Icons["Clock"] = "clock";
    Icons["Setting"] = "setting";
    Icons["Trash"] = "Trash";
    Icons["Bolt"] = "bolt";
    Icons["BoltSlash"] = "bolt-slash";
    Icons["Layers"] = "layers";
    Icons["DraggableDots"] = "draggabledots";
    Icons["AngleLeft"] = "AngleLeft";
    Icons["Star"] = "star";
    Icons["ExclamationTriangle"] = "exclamationTriangle";
    Icons["Chat"] = "comment-alt-lines";
    Icons["ToggleOn"] = "toggle-on";
    Icons["ToggleOff"] = "toggle-off";
    Icons["Info"] = "exclamation-circle";
    Icons["Reward"] = "gift";
    Icons["Envelop"] = "envelope-alt";
})(Icons = exports.Icons || (exports.Icons = {}));
//# sourceMappingURL=theming.js.map